import { infiniteQueryOptions } from '@tanstack/react-query';

import type { PaymentListItemKind } from '../model/payment.types';
import { paymentApi } from './payment.api';

export const queryKeys = {
    all: ['payment'] as const,
    lists: () => [...queryKeys.all, 'list'] as const,
    list: (clientId: string, kind?: PaymentListItemKind) =>
        [...queryKeys.lists(), clientId, kind ?? 'ALL'] as const,
};

export function paymentListOptions(clientId: string, kind?: PaymentListItemKind) {
    return infiniteQueryOptions({
        queryKey: queryKeys.list(clientId, kind),
        queryFn: ({ pageParam, signal }) =>
            paymentApi.getList({ clientId, kind, cursor: pageParam, pageSize: 50 }, signal),
        initialPageParam: null as string | null,
        getNextPageParam: (lastPage) => lastPage.nextCursor,
    });
}
